export const ROUTER_PERMISSION = {
    '/users': ['ADMIN_EMPRESA'],
    '/user/new': ['ADMIN_EMPRESA'],
    '/user/detail/:id': ['ADMIN_EMPRESA'],
    '/user/edit/:id': ['ADMIN_EMPRESA'],
    '/user/remove/:id': ['ADMIN_EMPRESA'],
    '/reports': ['ADMIN_EMPRESA'],
};